<template>
  <svg width="35" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.7143 9.07143H0V13.3571H25.7143V9.07143ZM25.7143 0.5H0V4.78571H25.7143V0.5ZM0 21.9286H17.1429V17.6429H0V21.9286ZM41.7857 12.2857L45 15.5L30.0214 30.5L20.3571 20.8571L23.5714 17.6429L30.0214 24.0714L41.7857 12.2857Z"
      fill="#00903C"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckedSvg'
}
</script>

<style></style>
